import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Reason} from "../../entities/reason";
import {ReasonService} from "../../services/reason.service";
import {Modal} from "flowbite";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-reason',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './reason.component.html',
  styleUrl: './reason.component.css'
})
export class ReasonComponent implements OnInit{
  constructor(private route: ActivatedRoute, private reasonService: ReasonService, private router: Router) {}

  reason: Reason = {id:"",title:"", topic:"", description:""}

  id: String = "";
  isReasonFromMe: Boolean = false;
  isSaved: Boolean = false;

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') ?? "";
    this.reasonService.getReason(this.id).then(reason => {
      this.reason = reason
      this.isReasonFromMe = this.reasonService.isReasonFromMe(reason)
      this.reasonService.isSaved(reason).then(result => this.isSaved=result);
      const modalEl = document.getElementById('info-popup');
      const privacyModal = new Modal(modalEl, {
        placement: 'center'
      });

      privacyModal.show();
      const route = (route: String)=>{
        this.router.navigate([route])
      }
      const saveReason = ()=>{
        return this.reasonService.saveReason(this.reason.id)
      }
      const closeModalEl = document.getElementById('close-modal');
      closeModalEl?.addEventListener('click', function() {
        privacyModal.hide();
        route("/reason-board");
      });

      const saveReasonEl = document.getElementById('save-button');
      saveReasonEl?.addEventListener('click', function() {
        saveReason().then(()=>{
          privacyModal.hide();
          route("/saved")
        });
      });

      const editReasonEl = document.getElementById('edit-button');
      editReasonEl?.addEventListener('click', function() {
        privacyModal.hide();
        route("/edit/"+reason.id)
      });
    });

  }
}
